// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__wrap--DvZyi {\n  display: inline-block;\n}\n.s-module__wrap--DvZyi img {\n  height: 26px;\n}\n", "",{"version":3,"sources":["webpack://./src/components/AvatarGroup/s.module.less"],"names":[],"mappings":"AAAA;EACI,qBAAA;AACJ;AAFA;EAIQ,YAAA;AACR","sourcesContent":[".wrap {\n    display: inline-block;\n\n    img {\n        height: 26px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "s-module__wrap--DvZyi"
};
export default ___CSS_LOADER_EXPORT___;
